module.exports = __webpack_public_path__ + "img/benefit-03-cropped.eda7638.jpg";